module.exports = __webpack_public_path__ + "img/IMG_20180628_091811.a8017571.jpg";